export const SNCR_INTEGRATION_ROUTE = "/integration/sncr";

export const INTEGRATION_LIST_ROUTE = "/integration";
